import { CartSliceType } from '@common/store/cart/slice';
import { addProductToCart, subtractProductFromCart } from '@common/store/cart/slice';
import { ProductsSliceType } from '@common/store/products/slice';
import { StoreInfoSliceType } from '@common/store/storeInfo/slice';
import { addToast } from '@common/store/toasts/slice';
import Button2 from '@components/Button2';
import SectionHeading from '@components/SectionHeading';
import Error from '@lib/Error';
import Loading from '@lib/Loading';
import classnames from 'classnames';
import React, { useRef } from 'react';

import ProductCard from './ProductCard';

interface ProductListProps {
  cart: CartSliceType;
  products: Record<string, ProductsSliceType>;
  addProductToCart: typeof addProductToCart;
  subtractProductFromCart: typeof subtractProductFromCart;
  addToast: typeof addToast;
  storeInfo: StoreInfoSliceType;
  type?: string;
  heading?: string;
}

const ProductList: React.FC<ProductListProps> = ({
  cart,
  products,
  addToast,
  storeInfo,
  addProductToCart,
  subtractProductFromCart,
}) => {
  const containerRef = useRef(null);

  const carouselList = products?.list?.results.slice(0, 6) || []; //carouselList

  if (!products?.isFetched) {
    return <Loading />;
  } else if (products?.isFetched && products?.error) {
    return <Error message={products.error} />;
  }

  return (
    <div className="ps-12 productListBg">
      <div className="product-showcase-container layout-container container mx-auto py-40 overflow-x-hidden relative">
        <SectionHeading className={'mb-24 md:mb-48 text-center mx-auto'}>{products.title}</SectionHeading>
        <div
          ref={containerRef}
          className={classnames('products-carousel flex flex-wrap items-stretch justify-center')}
          id={`productList-${products.id}`}
        >
          {carouselList?.map((product, index) => (
            <div className="product-card justify-center flex" key={index}>
              <ProductCard
                product={product}
                addProductToCart={addProductToCart}
                subtractProductFromCart={subtractProductFromCart}
                cartProductQuantity={cart.quantityByProductId[product.id] || 0}
                addToast={addToast}
                storeInfo={storeInfo}
              />
            </div>
          ))}
          <div className="product-card"></div>
          <div className="product-card"></div>
        </div>
        {products?.list?.results.length > 6 ? (
          <Button2 link={'/shop'} customClass={`view-more-${products.id} mx-auto`} text={'View All Products'} />
        ) : null}
      </div>
    </div>
  );
};

export default ProductList;
